import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Container } from "@mui/system";
import Player from "@vimeo/player";

export const Bizcochuelo = () => {
  const [endedVideo1, setEndedVideo1] = useState(false);
  const [endedVideo2, setEndedVideo2] = useState(false);
  const [endedVideo3, setEndedVideo3] = useState(false);
  const Capsula1 = useRef(null);
  const Capsula2 = useRef(null);
  const Capsula3 = useRef(null);

  useEffect(() => {
    const capsula1Player = new Player(Capsula1.current);
    const capsula2Player = new Player(Capsula1.current);
    const capsula3Player = new Player(Capsula1.current);

    capsula1Player.on("ended", () => {
      setEndedVideo1(true);
    });
    capsula2Player.on("ended", () => {
      setEndedVideo2(true);
    });
    capsula3Player.on("ended", () => {
      setEndedVideo3(true);
    });

    return () => {
      capsula1Player.off("ended");
      capsula2Player.off("ended");
      capsula3Player.off("ended");
    };
  }, []);

  return (
    <StyledContainer>
      <Container>
        <StyledMain>
          <StyledVideo>
            <iframe
              ref={Capsula1}
              width="100%"
              height="100%"
              src="https://player.vimeo.com/video/1157367999"
              frameBorder="0"
              allow="fullscreen; picture-in-picture"
              title="Premezclas Introducci&amp;amp;oacute;n"
              loading="lazy"
            />
          </StyledVideo>
          <StyledCapsulas>
            <section>
              <StyledVideo>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://player.vimeo.com/video/1157367999"
                  frameBorder="0"
                  allow="fullscreen; picture-in-picture"
                  title="Premezclas Introducci&amp;amp;oacute;n"
                  loading="lazy"
                />
              </StyledVideo>
              <Button color="secondary" variant="contained">
                Responder cuestionario
              </Button>
            </section>
            <section>
              <StyledVideo>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://player.vimeo.com/video/1157367999"
                  frameBorder="0"
                  allow="fullscreen; picture-in-picture"
                  title="Premezclas Introducci&amp;amp;oacute;n"
                  loading="lazy"
                />
              </StyledVideo>
              <Button disabled color="secondary" variant="contained">
                Responder cuestionario
              </Button>
            </section>
            <section>
              <StyledVideo>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://player.vimeo.com/video/1157367999"
                  frameBorder="0"
                  allow="fullscreen; picture-in-picture"
                  title="Premezclas Introducci&amp;amp;oacute;n"
                  loading="lazy"
                />
              </StyledVideo>
              <Button disabled color="secondary" variant="contained">
                Responder cuestionario
              </Button>
            </section>
          </StyledCapsulas>
        </StyledMain>
      </Container>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  background-color: #e5e5e5;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
`;

const StyledMain = styled.div`
  padding-top: 120px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
`;

const StyledCapsulas = styled.div`
  display: flex;
  justify-content: space-between;
  > section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    width: 30%;
    height: auto;
  }
`;
